// @flow
import { connect } from 'react-redux';
import { disbatch } from 'redux-act';

import { selectCartUUID, getCart, addCartProducts } from '@gandi/cart';

import BulkAddToCart, { type StateProps } from '../../components/BulkAddToCart';
import type { FullState, Dispatch, GetState } from '../../types';
import {
  startAddingToCart,
  stopAddingToCart,
  removeFromCart,
  getResultProductData,
} from '../modules/actions';
import { selectResults } from '../modules/selectors';

const selectAllAddedToCart = (state: FullState): boolean =>
  selectResults(state)
    .filter(result => result.isTransferable)
    .every(result => result.addedToCart);

const mapStateToProps = (state: FullState): StateProps => ({
  addedToCart: selectAllAddedToCart(state),
  cartId: selectCartUUID(state),
});

const addAllToCart = () => async (dispatch: Dispatch, getState: GetState) => {
  const results = selectResults(getState()).filter(
    result => !result.addedToCart && result.isTransferable,
  );

  const products = results.reduce((acc, result) => {
    const { productData, extra } = getResultProductData(result);

    return {
      // $FlowIgnore[prop-missing]
      data: acc.data ? [...acc.data, productData] : [productData],
      extra: {
        // $FlowIgnore[prop-missing]
        ...acc.extra,
        // $FlowFixMe[invalid-computed-prop]
        [productData.payload?.fqdn]: extra,
      },
    };
  }, {});

  try {
    disbatch(
      dispatch,
      results.map(({ fqdn }) => startAddingToCart(fqdn)),
    );
    await dispatch(
      addCartProducts({
        // $FlowFixMe[incompatible-call]
        productsData: products.data,
        extra: products.extra,
        options: {
          headers: { 'X-Dry-Run': 0 },
        },
      }),
    );
  } finally {
    disbatch(
      dispatch,
      results.map(({ fqdn }) => stopAddingToCart(fqdn)),
    );
  }

  return dispatch(getCart());
};

const removeAllFromCart = () => (dispatch: Dispatch, getState: GetState) => {
  const results = selectResults(getState());

  return Promise.allSettled(
    results
      .filter(result => result.addedToCart)
      .map(result => dispatch(removeFromCart(result))),
  );
};

const mapDispatchToProps = {
  addAllToCart,
  removeAllFromCart,
};

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
export default connect(mapStateToProps, mapDispatchToProps)(BulkAddToCart);
